export default __webpack_public_path__ + "static/media/solution-1-2-mobile.b8a0f362.jpg";